import { type FC } from 'react'
import { IconButton } from 'shared/ui'
import type { IAudioPlayerSummaryItem } from 'shared/ui/AudioPlayer'
import { useCopyToClipboard } from 'shared/hooks/useCopyToClipboard'
import styles from './styles.module.scss'

type ITranscriptActionsProps = {
  items: IAudioPlayerSummaryItem[]
}

export const AISummaryActions: FC<ITranscriptActionsProps> = ({ items }) => {
  const text = items
    .map((group, indexG) => {
      const isLast = items.length === indexG + 1
      const title = group.title
      const list = group.items
        .map((item, indexL) => {
          const isLast = group.items.length === indexL + 1

          if (isLast) return item.text

          return `${item.text}\n`
        })
        .join('')

      if (isLast) return `${title}\n\n${list}`

      return `${title}\n\n${list}\n\n\n`
    })
    .join('')
  const { onCopy } = useCopyToClipboard(text, { showToast: true, mode: 'stateless' })

  return (
    <div className={styles.actions}>
      <IconButton
        onClick={onCopy}
        icon={'copy'}
        variant={'icon'}
        size={'small'}
        color={'tertiary'}
        transparentInactive
        fontSize={16}
        tooltipProps={{
          label: 'Copy summary',
          placement: 'top',
        }}
        ariaLabel='Summary_copy'
      />
    </div>
  )
}
